import { PlanoContratadoModel } from "./plano-contratado-model";
import { PlanoModel } from "./plano-model";

export class PlanoAtualModel {
  constructor(
    public contratado: PlanoContratadoModel = new PlanoContratadoModel(),
    public plano: PlanoModel = new PlanoModel(),
  ) { }
}
